import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getUpdateIcneaPasswordUrl } from "./api-url.constants";
import { UpdateIcneaPasswordError } from "./errors";

interface UpdateIcneaPasswordBody {
  clientPassword: string;
  userId?: string;
}

export const updateIcneaPassword = async (body: UpdateIcneaPasswordBody): Promise<void> => {
  const response = await typedFetch(getUpdateIcneaPasswordUrl(body.userId), {
    method: API_METHODS.PATCH,
    body: JSON.stringify({
      clientPassword: body.clientPassword,
    }),
  });

  if (!response.ok) {
    throw new UpdateIcneaPasswordError();
  }
};
